import { Divider } from '@material-ui/core'
import React from 'react'
import { format } from 'date-fns'
import { Header, Row, Text } from '../Text'

function Calendar({ startDate, finishDate }: ICalendarProps) {
  return (
    <React.Fragment>
      <Header>Kalendarz</Header>
      <Divider />
      <Row>
        <Text>Start zakresu: {format(startDate, 'DD-MM-YYYY')}</Text>
      </Row>
      <Row>
        <Text>Koniec zakresu: {format(finishDate, 'DD-MM-YYYY')}</Text>
      </Row>
    </React.Fragment>
  )
}

export default Calendar

export interface ICalendarProps {
  startDate: Date
  finishDate: Date
}
